import { Link } from "react-router-dom";

import websiteLogo from "assets/images/header/websiteLogo.svg";
// import hamBurger from "assets/images/header/hamburger.svg";
import Button from "component/Button/Button";
// import useScreenMobile from "hooks/useScreenMobile";
// import bagIcon from "../../assets/images/ProductDetails/bagIcon.svg";

import "./header.scss";
import { scrollToTop } from "constants/ScrollToTop";
import { useEffect, useState } from "react";

import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";

const Header = ({ count, setCount }) => {
  // const isTab = useScreenMobile({ size: 992 });
  const isInDetails = location.pathname === "/details";
  const [hideHeader, setHideHeader] = useState(true);
  const [position, setPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const moving = window.pageYOffset;
      if (moving > 100) {
        setHideHeader(position > moving);
      } else {
        setHideHeader(true);
      }
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  //   const cls = hideHeader && isInDetails ? "" : "hidden";
  const cls = isInDetails && hideHeader ? "" : isInDetails ? "hidden" : "";

  //   const [isSticky, setIsSticky] = useState(false);

  return (
    <section className={`container header-sticky ${cls}`}>
      <div
        className="header"
        style={{ borderBottom: isInDetails ? "1px solid #eaeaea" : "" }}
      >
        <div className="headerLogo">
          <Link to="https://shop.neosapien.xyz">
            <img
              src={websiteLogo}
              alt="websiteLogo"
              className="websiteLogo"
              onClick={() => {
                scrollToTop();
                setCount(1);
              }}
            />
          </Link>
        </div>
        {/* {isTab ? (
          <img src={hamBurger} alt="websiteLogo" />
        ) 
        : ( */}
        <>
          {/* <div className="navLink">
              <Link to="/">Neo 1</Link>
              <Link to="/">About Us</Link>
              <Link to="/">Contact Us</Link>
            </div> */}
          {/* {isInDetails ? (
              <div className="bagBox">
                <img src={bagIcon} alt="" />
                <div className="cartCount">{count}</div>
              </div>
            ) : (
              <Button
                title="Order Now"
                onClick={() => navigate("/details")}
                padding="14px 22px"
              />
            )} */}
        </>
        {/* )} */}
        <>
          {isInDetails ? (
            // <div className="bagBox">
            //   <img src={bagIcon} alt="" />
            //   {count > 0 && <div className="cartCount">{count}</div>}
            // </div>
            <div></div>
          ) : (
            <Button
              title="Order Now"
              onClick={() => {
                logEvent(analytics, "order_now_header");
                window.location.href = "https://shop.neosapien.xyz";
                scrollToTop();
              }}
              padding="14px 22px"
            />
          )}
        </>
      </div>
    </section>
  );
};

export default Header;
